import { AxiosResponse } from 'axios';
import { useQuery } from 'react-query';

import axios from 'libs/Axios';
import { AxiosDefaultErrorEntity } from 'types/api/Common/ErrorTypes';
import {
  AccountabilityChartResponse,
  MyAccountabilityResponse,
} from 'types/api/Tenant/AccountabilityTypes';

export const ACCOUNTABILITY_QUERY_KEY = {
  CHART: 'ACCOUNTABILITY_CHART',
  ME: 'MY_ACCOUNTABILITIES',
};

export type AccountabilityChartScope = 'all' | 'me';

export function useGetAccountabilityChart(
  definitionId?: string,
  scope: AccountabilityChartScope = 'all'
) {
  return useQuery<AxiosResponse<AccountabilityChartResponse>, AxiosDefaultErrorEntity>(
    [ACCOUNTABILITY_QUERY_KEY.CHART, scope, definitionId],
    () =>
      axios
        .get(
          scope === 'me'
            ? `/api/v1/accountability/definitions/${definitionId}/me/chart`
            : `/api/v1/accountability/definitions/${definitionId}/chart`
        )
        .then((res) => res),
    { enabled: Boolean(definitionId) }
  );
}

export function useGetMyAccountabilities(definitionId?: string) {
  return useQuery<AxiosResponse<MyAccountabilityResponse>, AxiosDefaultErrorEntity>(
    [ACCOUNTABILITY_QUERY_KEY.ME, definitionId],
    () => axios.get(`/api/v1/accountability/definitions/${definitionId}/me`).then((res) => res),
    { enabled: Boolean(definitionId) }
  );
}
